import React from 'react';
import { RefreshCw, ArrowRightLeft, TrendingDown, CheckCircle } from 'lucide-react';
export const ValueAddedServices = () => {
  return <section className="py-20 bg-gradient-to-br from-primary-50 to-white" data-id="element-1219">
      <div className="container" data-id="element-1220">
        <div className="text-center mb-16" data-id="element-1221">
          <h2 className="section-title" data-id="element-1222">
            Maximize Your Assets: Loan Buy-Off & Refinance
          </h2>
          <p className="section-subtitle" data-id="element-1223">
            Switch to better terms and unlock additional value from your
            existing loans
          </p>
        </div>

        <div className="max-w-4xl mx-auto" data-id="element-1224">
          <div className="bg-white rounded-3xl shadow-2xl overflow-hidden border-2 border-primary-200" data-id="element-1225">
            <div className="grid md:grid-cols-2" data-id="element-1226">
              {/* Left Side - Problem */}
              <div className="p-8 bg-gray-50" data-id="element-1227">
                <div className="flex items-center gap-3 mb-6" data-id="element-1228">
                  <div className="w-12 h-12 bg-red-100 rounded-xl flex items-center justify-center" data-id="element-1229">
                    <TrendingDown size={24} className="text-red-600" data-id="element-1230" />
                  </div>
                  <h3 className="text-xl font-bold text-gray-900" data-id="element-1231">
                    Current Situation
                  </h3>
                </div>
                <ul className="space-y-4" data-id="element-1232">
                  <li className="flex items-start gap-3" data-id="element-1233">
                    <span className="text-red-600 font-bold" data-id="element-1234">✗</span>
                    <span className="text-gray-700" data-id="element-1235">High monthly payments</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-1236">
                    <span className="text-red-600 font-bold" data-id="element-1237">✗</span>
                    <span className="text-gray-700" data-id="element-1238">
                      Unfavorable interest rates
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-1239">
                    <span className="text-red-600 font-bold" data-id="element-1240">✗</span>
                    <span className="text-gray-700" data-id="element-1241">Limited cash flow</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-1242">
                    <span className="text-red-600 font-bold" data-id="element-1243">✗</span>
                    <span className="text-gray-700" data-id="element-1244">
                      No room for emergencies
                    </span>
                  </li>
                </ul>
              </div>

              {/* Right Side - Solution */}
              <div className="p-8 bg-gradient-to-br from-primary-600 to-primary-700 text-white" data-id="element-1245">
                <div className="flex items-center gap-3 mb-6" data-id="element-1246">
                  <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center" data-id="element-1247">
                    <RefreshCw size={24} className="text-white" data-id="element-1248" />
                  </div>
                  <h3 className="text-xl font-bold" data-id="element-1249">Our Solution</h3>
                </div>
                <ul className="space-y-4" data-id="element-1250">
                  <li className="flex items-start gap-3" data-id="element-1251">
                    <CheckCircle size={20} className="flex-shrink-0 mt-0.5" data-id="element-1252" />
                    <span data-id="element-1253">Lower monthly payments</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-1254">
                    <CheckCircle size={20} className="flex-shrink-0 mt-0.5" data-id="element-1255" />
                    <span data-id="element-1256">Competitive interest rates</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-1257">
                    <CheckCircle size={20} className="flex-shrink-0 mt-0.5" data-id="element-1258" />
                    <span data-id="element-1259">Get additional top-up cash</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-1260">
                    <CheckCircle size={20} className="flex-shrink-0 mt-0.5" data-id="element-1261" />
                    <span data-id="element-1262">Improved cash flow management</span>
                  </li>
                </ul>
              </div>
            </div>

            {/* Bottom CTA */}
            <div className="p-8 bg-primary-50 border-t-2 border-primary-200" data-id="element-1263">
              <div className="flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-1264">
                <div data-id="element-1265">
                  <h4 className="text-xl font-bold text-gray-900 mb-2" data-id="element-1266">
                    Ready to Lower Your Payments?
                  </h4>
                  <p className="text-gray-600" data-id="element-1267">
                    Switch your existing loan to Geldhaus and get a top-up
                  </p>
                </div>
                <a href="#apply-now" className="btn-primary flex items-center gap-2 whitespace-nowrap" data-id="element-1268">
                  <ArrowRightLeft size={20} data-id="element-1269" />
                  Refinance Now
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};